export function schema_ftp() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column_name: {
				type: "string",
				title: "Colonne des noms de fichiers"
			},
			column_folder: {
				type: "string",
				title: "Dossier ou colonne des noms des dossiers"
			},
			column_url: {
				type: "string",
				title: "Colonne des noms des urls pour envoi des fichiers"
			},
			column_action: {
				type: "string",
				title: "Action ou colonne d'actions (envoyer/récupérer/liste/supprimer/supprimer dossier/vider)"
			},
			column_response: {
				type: "string",
				title: "Colonne de réponse"
			},
			column_error: {
				type: "string",
				title: "Colonne des erreurs"
			}
		},
	};
}
